import { API_ENDPOINTS } from "@features/tickets/config/constants";
import type { TicketComment } from "@features/tickets/types/ticket.types";
import api from "@lib/api/client";
import { queryKeys } from "@lib/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

export function useTicketComments(ticketId: number | string) {
  return useQuery({
    queryKey: queryKeys.tickets.comments.all(ticketId),
    queryFn: async () => {
      const response = await api.get<TicketComment[]>(API_ENDPOINTS.TICKETS.COMMENTS(ticketId));
      return response.data;
    },
    enabled: !!ticketId,
  });
}
